/**
 * Returns the base url of the app
 */
function getBaseUrl() {
  const {
    VITE_URL_SCHEME,
    VITE_URL_DEFAULT_SUBDOMAIN,
    VITE_URL_DOMAIN
  } = import.meta.env;

  return `${VITE_URL_SCHEME}${VITE_URL_DEFAULT_SUBDOMAIN}.${VITE_URL_DOMAIN}`;
}

export default getBaseUrl;
